// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","highlightedMentions":"_2PZHId8inSfY1W67kQCBCr"};